const Dateformat = {

DDMMYYYHHMMSS: "DD-MMM-YYYY hh:mm:ss",
DDMMYYYY : "DD-MMM-YYYY",
YYYYMMDD : "YYYY-MM-DD",
MMYYYY: "MM-YYYY",
Mmyy: "MM-yy",
MMMMYYYY: 'MMMM, YYYY'

}

export default Dateformat;